import { CommonModule } from '@angular/common';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
// This Module's Components
import { RecentSearchesComponent } from './recent-searches.component';

@NgModule({
  imports: [CommonModule, ModalModule.forRoot(), TabsModule.forRoot()],
  declarations: [RecentSearchesComponent],
  exports: [RecentSearchesComponent]
})
export class RecentSearchesModule {}
